import React, { createContext, useCallback, useContext, useState } from 'react'
import { SuccessDialog, WarningDialog } from 'components/Shared/Dialogs'

const RowMenuOptionsContext = createContext({
  menuOptions: null
})

export function RowMenuOptionsProvider ({ menu, onDeleteSuccess, children }) {
  const [selectedRowId, setSelectedRowId] = useState('')
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const [successDeletingDialogOpen, setSuccessDeletingDialogOpen] = useState(false)

  const onDeleteDialogClose = (isDeleteConfirmed) => {
    if (isDeleteConfirmed === true) {
      menu.delete.onDelete(selectedRowId)
        .then(() => {
          setSelectedRowId('')
          setSuccessDeletingDialogOpen(true)
          onDeleteSuccess()
        })
        .catch(error => {
          if (menu.delete.onDeleteError) {
            menu.delete.onDeleteError(error)
          }
        })
    }
    setShowDeleteDialog(false)
  }

  const rowMenuOptions = useCallback(row => {
    const menuOptions = {}

    if (menu.edit && menu.edit.isEditable?.(row) !== false) {
      menuOptions.edit = {
        onClick: () => menu.edit.onClick(row)
      }
    }
    if (menu.copy && menu.copy.isCopyable?.(row) !== false) {
      menuOptions.copy = {
        onClick: () => menu.copy.onClick(row)
      }
    }
    if (menu.delete && menu.delete.isDeletable?.(row) !== false) {
      menuOptions.delete = {
        onClick: () => {
          setShowDeleteDialog(true)
          setSelectedRowId(row.id)
        }
      }
    }
    return menuOptions
  }, [menu])

  const value = {
    menuOptions: rowMenuOptions
  }

  if (!menu) return children

  return (
    <RowMenuOptionsContext.Provider value={value}>
      <SuccessDialog
        open={successDeletingDialogOpen}
        onClose={() => setSuccessDeletingDialogOpen(false)}
        content={'notifications.success.delete'}
      />
      <WarningDialog open={showDeleteDialog}
                     onClose={onDeleteDialogClose}
                     title={menu.delete?.deleteDialog?.title}
                     content={menu.delete?.deleteDialog?.content}/>
      {children}
    </RowMenuOptionsContext.Provider>
  )
}

export function useRowMenuOptions () {
  const { menuOptions } = useContext(RowMenuOptionsContext)
  return { menuOptions }
}
